import { z } from 'zod';

export const pricingDiagnosticCategorySchema = z.enum([
  'hard_validation_error',
  'legacy_compatible_warning',
  'mapping_warning',
  'missing_data_warning',
  'currency_fallback_warning',
  // A user-entered value the engine honours but can no longer reconcile with its
  // own formula — nothing is malformed, so it is neither a validation error nor a
  // mapping problem. Only the adjustment blocks' Price override raises one today
  // (XT-563).
  'stale_override_warning',
]);

export const pricingDiagnosticSeveritySchema = z.enum(['error', 'warning']);

export const pricingDiagnosticPathSegmentSchema = z.union([
  z.string(),
  z.number().int(),
]);

export const pricingDiagnosticSchema = z.object({
  id: z.string().min(1).optional(),
  category: pricingDiagnosticCategorySchema,
  severity: pricingDiagnosticSeveritySchema,
  code: z.string().min(1),
  message: z.string().min(1),
  path: z.array(pricingDiagnosticPathSegmentSchema).optional(),
  itemId: z.string().min(1).optional(),
  lineId: z.string().min(1).optional(),
  intentId: z.string().min(1).optional(),
  blocksPersistence: z.boolean(),
  details: z.record(z.string(), z.unknown()).optional(),
});

export const pricingDiagnosticsSchema = z.array(pricingDiagnosticSchema);

export type PricingDiagnosticCategory = z.infer<
  typeof pricingDiagnosticCategorySchema
>;
export type PricingDiagnosticSeverity = z.infer<
  typeof pricingDiagnosticSeveritySchema
>;
export type PricingDiagnostic = z.infer<typeof pricingDiagnosticSchema>;
export type PricingDiagnostics = z.infer<typeof pricingDiagnosticsSchema>;
